import { useEffect, useState } from 'react';
import { api } from '../lib/api';

let navCache = null;
let settingsCache = null;

export function useCatalogNav() {
  const [nav, setNav] = useState(navCache || []);
  useEffect(() => {
    api.get('/catalog/nav').then((r) => { navCache = r.data; setNav(r.data); }).catch(() => {});
  }, []);
  return nav;
}

export function useSiteSettings() {
  const [s, setS] = useState(settingsCache);
  useEffect(() => {
    api.get('/settings/site').then((r) => { settingsCache = r.data; setS(r.data); }).catch(() => {});
  }, []);
  return s;
}
